import { ConfigProvider, Tabs } from "antd";
import { TabsProps } from "antd/lib";
import classNames from "classnames";
type CustomTabsProps = TabsProps & {
  compact?: boolean;
};
export const CustomTabs = ({
  className,
  compact = false,
  ...props
}: CustomTabsProps) => <ConfigProvider theme={{
  components: {
    Tabs: {
      itemColor: "var(--color-gray-400)",
      itemHoverColor: "var(--color-gray-700)",
      itemSelectedColor: "var(--color-gray-700)",
      inkBarColor: "var(--color-gray-800)",
      cardPadding: "12px 16px 10px 16px",
      cardGutter: 12,
      cardBg: "var(--color-gray-200)",
      ...(compact ? {
        cardPadding: "8px 8px 6px 8px"
      } : {}),
      ...(compact ? {
        cardGutter: 8
      } : {})
    }
  }
}} data-sentry-element="ConfigProvider" data-sentry-component="CustomTabs" data-sentry-source-file="CustomTabs.tsx">
    <Tabs type="card" className={classNames("mb-0 !border-none", "[&_.ant-tabs-nav]:!mb-0", "[&_.ant-tabs-tab]:!rounded-t-lg", "[&_.ant-tabs-tab]:!shadow", "[&_.ant-tabs-tab]:!font-medium", "[&_.ant-tabs-tab]:!border", "[&_.ant-tabs-tab]:!border-b-0", "[&_.ant-tabs-tab]:!tracking-[0.01em]", "[&_.ant-tabs-tab]:!border-gray-200", "[&_.ant-tabs-tab-active]:!bg-surface", "[&_.ant-tabs-tab.ant-tabs-tab-active]:!border-gray-200", "[&_.ant-tabs-tab:not(.ant-tabs-tab-active):hover]:!bg-gray-100", "[&_.ant-tabs-tab:not(.ant-tabs-tab-active):hover]:!border-gray-400", "[&_.ant-tabs-tab:not(.ant-tabs-tab-active):hover]:!shadow", className)} {...props} data-sentry-element="Tabs" data-sentry-source-file="CustomTabs.tsx" />
  </ConfigProvider>;